import component from './component';

export default component;



// WEBPACK FOOTER //
// ./src/components/Header/index.js